import { Fragment } from "@wordpress/element";
import { __ } from "@wordpress/i18n";
import { InnerBlocks } from '@wordpress/block-editor';
import { select } from '@wordpress/data';
import './style.scss';

const Tabs = {
  title: __('Tabs'),
  description: __('A responsive tabs block for the ABS theme'),
  icon: 'category',
  attributes: {
    blockId: {
      type: 'string',
      default: '',
    },
    tabs : {
      type:   'array',
      default: [],
    },
  },
  supports: {
    customClassName: false,
  },
  edit: ({ className, clientId, attributes }) => {
    const allowedBlocks = [ 'abs/content-tab-block' ];
    const template = [
      [ 'abs/content-tab-block', { title: 'My first tab' } ],
    ];
    const currentBlock = select( 'core/block-editor' ).getBlocksByClientId( clientId )[ 0 ];
    const childBlocks = currentBlock.innerBlocks;
    const clientIds = childBlocks.map( block => block.clientId );
    const tempTabAttributes = [];

    clientIds.forEach(clientId => {
      const tabAttributes = select( 'core/block-editor' ).getBlockAttributes( clientId );
      tempTabAttributes.push(tabAttributes);
    });

    attributes.clientId = clientId;
    attributes.tabs = tempTabAttributes;

    return (
      <Fragment>
        <div className={ className }>
          <div className="tabs">
            <InnerBlocks allowedBlocks={ allowedBlocks } template={ template } />
          </div>
        </div>
      </Fragment>
    );
  },

  save: ({ attributes }) => {
    const { blockId, tabs } = attributes;
    const tabId = blockId + 'Tab';
    const tabContentId = blockId + 'TabContent';

    return (
      <div>
        <ul className="nav nav-tabs" id={tabId} role="tablist">
            {tabs.map((tab) => <li className="nav-item" role="presentation"><a className="nav-link" id={`${tab.blockId}-tab`} data-bs-toggle="tab" href={`#panel-${tab.blockId}`} role="tab" aria-controls={tab.blockId} aria-selected="false">{tab.title}</a></li>)}
        </ul>
        <div className="tab-content" id={tabContentId}>
          <InnerBlocks.Content />
        </div>
      </div>
    );
  },

  deprecated: [
    {
      attributes: {
        blockId: {
          type: 'string',
          default: '',
        },
        tabs: {
          type: 'array',
          default: [],
        },
      },
      save: ({ attributes }) => {
        const { blockId, tabs } = attributes;
        const tabId = blockId + 'Tab';
        const tabContentId = blockId + 'TabContent';

        return (
          <div>
            <ul className="nav nav-tabs" id={tabId} role="tablist">
                {tabs.map((tab) => <li className="nav-item" role="presentation"><a className="nav-link" id={`${tab.blockId}-tab`} data-toggle="tab" href={`#panel-${tab.blockId}`} role="tab" aria-controls={tab.blockId} aria-selected="false">{tab.title}</a></li>)}
            </ul>
            <div className="tab-content" id={tabContentId}>
              <InnerBlocks.Content />
            </div>
          </div>
        );
      }
    }
  ],
};

export default Tabs;